<div class="no-record">
    <ng-container>
        <div class="no-records">
            <div class="p-8 sm:p-16 border-t text-2xl font-semibold tracking-tight text-center">
                {{'SYSTEM.NO_RECORDS' | translate}}
            </div>
        </div>
    </ng-container>
</div>
